import { GlobalLoading, Login, TopBar } from "@nxt-platform/global-components";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useSession } from "@descope/react-sdk";
import { UserSidebarNav } from "../components/layout/UserSidebarNav";
import { usePageTitle } from "../features/page-title/pageTitle";


export const Route = createFileRoute('/me')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isAuthenticated, isSessionLoading } = useSession();
  usePageTitle('Login', undefined, !isSessionLoading && !isAuthenticated);

  if (isSessionLoading) return <GlobalLoading />;
  if (!isAuthenticated) return <Login />;

  return (
    <div className="min-h-dvh bg-background">
      <TopBar className="relative z-40" logo="tickaroo" />
      <div className="flex flex-col lg:flex-row lg:items-stretch">
        <UserSidebarNav />
        <div className="flex-1 px-4 pb-6 pt-4 lg:px-6 lg:py-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
